import React, { createContext, useContext, useEffect, useState } from "react";
const InstallationOrderContext = createContext({});

export const InstallationOrderContextProvider = ({ children }) => {
    const [valueSearch, setValueSearch] = useState(null)
    useEffect(() => {
    }, [])
    return (
        <InstallationOrderContext.Provider
            value={{
                valueSearch, setValueSearch
            }}
        >
            {children}
        </InstallationOrderContext.Provider>
    );
};

export default function useInstallationOrderContext() {
    const context = useContext(InstallationOrderContext);
    return context;
}
